/** Used to add <head> tags to the enterprise pages.
 * E.g. custom open graph image for all enterprise pages. */
export const EnterpriseHeadProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <meta property="og:image" content="https://theconradapp.com/enterprise-og-img.jpg" />
      {children}
    </>
  )
}
